import axios from 'axios';
import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { Alert, Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { CONCURSOAPI } from '../../../../../../const';
import es from '../../../../../../yup-es';
import { CampoFormik } from '../../../../../CompUtils';
import FormSection from '../../../../../CompUtils/FormSection';
import { finalize, init } from '../../../../../GlobalFeedback/feedbackSlice';

import LinkBtn from '../../../../../CompUtils/LinkBtn';
import { SuccessErrorDlg } from '../../../../../CompUtils/SuccessErrorDlg';
import { verBasePuesto } from '../../../../Gestion/gestionConcursoSlice';

export const ModalCargaBasesYCondiciones = ({
  idPuesto,
  pathBases = '',
  withActions = false,
  showCargaBasesModal = false,
  handleCloseModal,
}) => {
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState('');
  const [bases, setBases] = useState('');
  const [successFile, setSuccessFile] = useState(false);

  const FILE_TYPES_BASES = ['pdf', 'PDF'];

  function validarTipoArchivoBases(value) {
    if (value.name) return FILE_TYPES_BASES.includes(value.name.split('.').pop());
    if (value) return FILE_TYPES_BASES.includes(value.split('.').pop());
    return false;
  }
  yup.setLocale(es);
  const schemabases = yup.object({
    basesFile: yup
      .mixed()
      .test(
        'fileType',
        'Tipo de archivo no soportado',
        (value) => !value || validarTipoArchivoBases(value),
      ),
  });
  const initialBases = {
    basesFile: {},
  };
  const handleSubmitBases = (formikValues, action) => {
    setErrorMsg('');
    dispatch(init());
    const copy = Object.assign({}, formikValues);
    var formData = new FormData();
    if (copy.basesFile) {
      formData.append('file', copy.basesFile);
    }
    axios
      .patch(`${CONCURSOAPI}/puesto/file/bbycc/${idPuesto}`, formData)
      .then((res) => {
        setBases(res.data);
        dispatch(finalize());
        setSuccessFile(true);
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          // Request made and server responded
          setErrorMsg(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          setErrorMsg(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMsg(error.message);
        }
      });
  };

  function handleClose() {
    handleCloseModal(false);
  }

  useEffect(() => {
    setBases(pathBases);
  }, []);

  return (
    <>
      {/* Modal Carga Perfiles */}
      <Modal show={showCargaBasesModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Carga Archivo de Perfiles</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {successFile && (
            <SuccessErrorDlg
              error={''}
              success={'Archivo cargado con éxito!'}
              onClose={() => {
                setSuccessFile(false);
              }}
            />
          )}
          {withActions && (
            <Formik
              validationSchema={schemabases}
              validateOnChange={false}
              initialValues={initialBases}
              onSubmit={handleSubmitBases}>
              {(formik) => (
                <Form noValidate onSubmit={formik.handleSubmit} id="cargaBasesForm">
                  <Form.Group as={Row} className="align-items-center">
                    <Col sm="9">
                      <CampoFormik
                        type="file"
                        label="Archivo de Bases y Condiciones a importar"
                        name="basesFile"
                        formik={formik}
                        col={{ sm: 4 }}
                      />
                    </Col>
                    <Col sm="1">
                      <Button variant="primary" type="submit">
                        <i className="icono-arg-nube-subir-datos"></i>
                      </Button>
                    </Col>
                    <Col sm="2">
                      <p className="text-danger">
                        <small>{errorMsg}</small>
                      </p>
                    </Col>
                  </Form.Group>
                </Form>
              )}
            </Formik>
          )}
          <FormSection></FormSection>
          {bases !== '' && bases != null && (
            <>
              <BaseBtn className="text-center align-middle" idPuesto={idPuesto}></BaseBtn>
            </>
          )}
          {bases === '' ||
            (bases == null && <Alert variant="danger">Bases y Condiciones no cargadas</Alert>)}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};
const BaseBtn = (showError, idPuesto = '') => {
  const dispatch = useDispatch();

  const handleViewPerfil = () => {
    dispatch(
      verBasePuesto({
        idPuesto: idPuesto.idPuesto,
      }),
    );
  };
  return (
    <LinkBtn onClick={handleViewPerfil} size="sm" transparent>
      <h5 className="text-center">Archivo Bases y Condiciones</h5>
    </LinkBtn>
  );
};
